import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

/**
 * Guard that allows access only to unauthenticated users (guests).
 * Redirects to '/busqueda-individual' if the user is already authenticated.
 */
export const guestGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);

    if (isPlatformBrowser(platformId)) {
        if (authService.isAuthenticated()) {
            return router.createUrlTree(['/busqueda-individual']);
        }
    }

    return true;
};
